export const HockeyPenaltyTypes = [
  {id: 1, code: 'АГРЕС', title: 'Агрессор в драке'},
  {id: 2, code: 'АТ-В-ГОЛ', title: 'Атака в голову или шею'},
  {id: 3, code: 'АТ-ВР', title: 'Атака вратаря'},
  {id: 4, code: 'АТ-СЗ', title: 'Атака сзади'},
  {id: 5, code: 'БЛОК', title: 'Блокировка'},
  {id: 6, code: 'БР-КЛ', title: 'Бросок клюшки'},
  {id: 7, code: 'ВБ-ШБ', title: 'Выброс шайбы'},
  {id: 8, code: 'ГРУБ', title: 'Грубость'},
  {id: 9, code: 'ДИСЦ', title: 'Дисциплинарный штраф'},
  {id: 10, code: 'ДИС-КН', title: 'Дисциплинарный до конца матча'},
  {id: 11, code: 'ДРАКА', title: 'Драка'},
  {id: 12, code: 'ЗАЧИН', title: 'Зачинщик драки'},
  {id: 13, code: 'ЗД-ИГ', title: 'Задержка игры'},
  {id: 14, code: 'ЗД-КЛ-СП', title: 'Задержка клюшки соперника'},
  {id: 15, code: 'ЗД-КЛ', title: 'Задержка клюшкой'},
  {id: 16, code: 'ЗД-СП', title: 'Задержка соперника'},
  {id: 17, code: 'ЗД-ШБ', title: 'Задержка шайбы руками'},
  {id: 18, code: 'СЛ-КЛ', title: 'Игра со сломанной клюшкой'},
  {id: 19, code: 'ВП-КЛ', title: 'Игра высоко поднятой клюшкой'},
  {id: 20, code: 'КЛ-УД', title: 'Колющий удар'},
  {id: 21, code: 'СК-ШТ', title: 'Малый скамеечный штраф'},
  {id: 22, code: 'МШ', title: 'Матч-штраф'},
  {id: 23, code: 'НП-АТ', title: 'Неправильная атака'},
  {id: 24, code: 'ЧС-СТ', title: 'Нарушение численного состава'},
  {id: 25, code: 'НС-КЛ', title: 'Нестандартная клюшка'},
  {id: 26, code: 'НАР-ЭК', title: 'Опасное снаряжение'},
  {id: 27, code: 'НС-ПВ', title: 'Оскорбление судей и неспортивное поведение'},
  {id: 28, code: 'ОТ-ИГ', title: 'Отказ начать игру'},
  {id: 29, code: 'ОТСЧ', title: 'Отсечение'},
  {id: 30, code: 'ПЛЕВОК', title: 'Плевок'},
  {id: 31, code: 'ПОДН', title: 'Подножка'},
  {id: 32, code: 'ПОДС', title: 'Подсечка'},
  {id: 33, code: 'ПР-ИН', title: 'Предупреждение инфекций'},
  {id: 34, code: 'ПК-СК', title: 'Покидание скамейки во время конфликта'},
  {id: 35, code: 'СД-ВР', title: 'Сдвиг ворот'},
  {id: 36, code: 'СИМ', title: 'Симуляция'},
  {id: 37, code: 'ТЛ-БР', title: 'Толчок на борт'},
  {id: 38, code: 'ТЛ-КЛ', title: 'Толчок клюшкой'},
  {id: 39, code: 'УД-ГОЛ', title: 'Удар головой'},
  {id: 40, code: 'УД-КЛ', title: 'Удар клюшкой'},
  {id: 41, code: 'УД-К-КЛ', title: 'Удар концом клюшки'},
  {id: 42, code: 'УД-КОЛ', title: 'Удар коленом'},
  {id: 43, code: 'УД-ЛОК', title: 'Удар локтем'},
  {id: 44, code: 'УД-НГ', title: 'Удар ногой'},
  {id: 45, code: 'УКУС', title: 'Укус'},
  {id: 46, code: 'КН-ЗР', title: 'Физический контакт со зрителем'},
  {id: 47, code: 'ШТ-ВР', title: 'Штраф вратаря'},
];
export const HockeyPenaltyTypesEn = [
  {id: 1, code: 'AGGR', title: 'Агрессор в драке'},
  {id: 2, code: 'AT-HD', title: 'Attack to the head or neck'},
  {id: 3, code: 'AT-GO', title: 'Goalkeeper attack'},
  {id: 4, code: 'AT-BH', title: 'Attack from behind'},
  {id: 5, code: 'BLOCK', title: 'Blocking'},
  {id: 6, code: 'TH-ST', title: 'Throwing a stick'},
  {id: 7, code: 'PC-RL', title: 'Puck release'},
  {id: 8, code: 'RUDE', title: 'Rudeness'},
  {id: 9, code: 'DISC', title: 'Disciplinary penalty'},
  {id: 10, code: 'DISC-EM', title: 'Disciplinary until the end of the match'},
  {id: 11, code: 'FIGHT', title: 'Fight'},
  {id: 12, code: 'IN-FG', title: 'The instigator of the fight'},
  {id: 13, code: 'GD', title: 'Game delay'},
  {id: 14, code: 'HD-OP-ST', title: 'Holding an opponent\'s stick'},
  {id: 15, code: 'ST-HD', title: 'Stick hold'},
  {id: 16, code: 'DL-OP', title: 'Delaying the opponent'},
  {id: 17, code: 'HL-PC-HD', title: 'Holding the puck with your hands'},
  {id: 18, code: 'PL-BS', title: 'Playing with a broken stick'},
  {id: 19, code: 'HSP', title: 'High stick play'},
  {id: 20, code: 'THR', title: 'Thrust'},
  {id: 21, code: 'MI-BE', title: 'Minor bench penalty'},
  {id: 22, code: 'MP', title: 'Match penalty'},
  {id: 23, code: 'WR-AT', title: 'Wrong attack'},
  {id: 24, code: 'NM-VO', title: 'Violation of numerical composition'},
  {id: 25, code: 'NS-ST', title: 'Non-standard stick'},
  {id: 26, code: 'DE', title: 'Dangerous equipment'},
  {id: 27, code: 'INS-REF', title: 'Insulting referees and unsportsmanlike conduct'},
  {id: 28, code: 'RF-SG', title: 'Refusal to start the game'},
  {id: 29, code: 'CO', title: 'Cut-off'},
  {id: 30, code: 'SPIT', title: 'Spit'},
  {id: 31, code: 'STEP', title: 'Step'},
  {id: 32, code: 'UND', title: 'Undercut'},
  {id: 33, code: 'PR-INF', title: 'Prevention of infections'},
  {id: 34, code: 'LE-BE', title: 'Leaving the bench during a conflict'},
  {id: 35, code: 'GA-SH', title: 'Gate shift'},
  {id: 36, code: 'SIM', title: 'Simulation'},
  {id: 37, code: 'PU-BR', title: 'Push on board'},
  {id: 38, code: 'PU-ST', title: 'Stick push'},
  {id: 39, code: 'AT-HD', title: 'Head kick'},
  {id: 40, code: 'HT-ST', title: 'Hit with a stick'},
  {id: 41, code: 'HT-ST-E', title: 'Hit with the end of the stick'},
  {id: 42, code: 'ST-KN', title: 'Knee strike'},
  {id: 43, code: 'ST-EB', title: 'Elbow strike'},
  {id: 44, code: 'KICK', title: 'Kick'},
  {id: 45, code: 'BITE', title: 'Bite'},
  {id: 46, code: 'CN-VW', title: 'Physical contact with the viewer'},
  {id: 47, code: 'PN-GO', title: 'Goalkeeper penalty'},
];
